import { getFirebaseAuth } from '../firebase/firebase';
import HttpClientWithRetry from '../httpclient/httpClientWithRetry';

export class AuthenticatedHttpService {
  async prepareHttpClient(baseUrl) {
    const ensuredBaseUrl = baseUrl || process.env.VUE_APP_BACKEND_URL;

    const httpClient = new HttpClientWithRetry({
      serviceConfiguration: {
        baseUrl: ensuredBaseUrl,
        requestTimeoutInMs: 30000,
      },
      retryConfiguration: {
        retry: 0,
      },
    });

    const idToken = await getFirebaseAuth().currentUser.getIdToken(false);
    httpClient.setHeaders({
      Accept: 'application/json',
      Authorization: `Bearer ${idToken}`,
    });
    return httpClient;
  }
}
